import CombinedRequestHandler from '../apiRequestHandler/combinedRequestHandler';
import ApiClient from '../../../utils/ApiClient';
import Config from '../../../config';
import ApiRequest from './apiRequest';

//handlers for api request actions
import feedbackRequestHandler from '../apiRequestHandler/feedbackRequest';

export default () => {
    const requestHandlers = [
        feedbackRequestHandler
    ]
    const apiClient = new ApiClient();
    const combinedRequestHandler = new CombinedRequestHandler(apiClient, Config.api, requestHandlers);
    const apiRequest = new ApiRequest(combinedRequestHandler);
    return Object.keys(apiRequest).map(key => store => next => action => apiRequest[key](store, next, action));
}


// WEBPACK FOOTER //
// ./modules/Common/middleware/apiRequestFactory.js